"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function AddNewVersionIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M5.841,13.31a1.048,1.048,0,0,0,.507.9l8.031,4.856a1.041,1.041,0,0,0,1.083,0l8.026-4.853a1.046,1.046,0,0,0,0-1.8L15.465,7.56a1.036,1.036,0,0,0-1.086,0L6.353,12.41A1.051,1.051,0,0,0,5.841,13.31Zm9.08-4.093L21.69,13.31,14.921,17.4,8.15,13.31Z" }),
        react_1.default.createElement("path", { d: "M23.493,17.2l-.977-.591-7.054,4.265a1.035,1.035,0,0,1-1.083,0L7.325,16.609l-.976.59a1.046,1.046,0,0,0,0,1.794l8.031,4.855a1.041,1.041,0,0,0,1.083,0l8.03-4.855a1.046,1.046,0,0,0,0-1.794Z" }),
        react_1.default.createElement("polygon", { points: "5.6 9.5 5.6 5.6 9.5 5.6 9.5 3.9 5.6 3.9 5.6 0 3.9 0 3.9 3.9 0 3.9 0 5.6 3.9 5.6 3.9 9.5 5.6 9.5" })));
}
exports.default = AddNewVersionIcon;
